<app-tool-loader [isLoading]="isLoading()" positionUnset="true">
  <form [formGroup]="form.formGroup">

      <div class="pb-5 field" >
        <div class="flex items-center">
          <p-checkbox
            [formControlName]="form.formControlNames.useMudPits"
            inputId="useMudPits"
            binary="true"
            (onChange)="this.useMudPits = $event.checked;"
          ></p-checkbox>
          <label for="useMudPits" class="ml-2">Circulate through Mud Pits</label>
        </div>
      </div>
    
    <p-tabs value="0" (valueChange)="selectedTabChange.emit($event)">
      <p-tablist>
        <p-tab value="0">Operation Details</p-tab>
        <p-tab value="1">Drill String
          @if (drillpipeMissing) {
            <i class="validation-error pi pi-exclamation-circle pl-1" pTooltip="Drill string not specified."></i>
          }
        </p-tab>
        @if (showRiser) {
          <p-tab value="2">Riser
            @if (form.formGroup.controls?.insideDiameter.invalid || form.formGroup.controls?.outsideDiameter.invalid) {
              <i class="validation-error pi pi-exclamation-circle pl-1" pTooltip="Operation not saved, some required inputs not specified."></i>
            }
          </p-tab>
        }
        @if (useMudPits) {
          <p-tab value="3">Mud Pits
            @if (form.formGroup.controls.mudPits.invalid) {
              <i class="validation-error pi pi-exclamation-circle pl-1" pTooltip="Operation not saved, double check Mud Pit inputs."></i>
            }
          </p-tab>
        }
      </p-tablist>

      <p-tabpanels class="pl-4 pr-2">
        <p-tabpanel value="0">
          <!-- <div [hidden]="true" class="flex flex-col">
            <label for="pressure"> Time since last operation</label>
            <p-inputgroup>
              <p-checkbox [formControlName]="form.formControlNames.isRunInHole" (onChange)="rihChange($event, true)"
                binary="true" [disabled]="isReadOnly">
              </p-checkbox>
              <p-inputNumber [disabled]="rihDisabled" [formControlName]="form.formControlNames.runInHoleTime">
              </p-inputNumber>
              <p-inputgroup-addon>hr</p-inputgroup-addon>
              @if (form.formGroup.controls.runInHoleTime.invalid) {
                <p class="validation-error">Allowed range: 0 - 100000 hrs</p>
              }
            </p-inputgroup>
          </div> -->

          <div class="flex flex-wrap gap-4">
            <!-- Left Column -->
            <div class="flex flex-col flex-1 min-w-[150px] space-y-2">

              <app-standard-fluid [formControlName]="form.formControlNames.standardFluidFlow"
                [operationType]="operationType" [userUnits]="userUnits">
              </app-standard-fluid>

              <div class="flex flex-col">
                <label for="startDrillingMd">Start Drilling Depth</label>
                <p-inputgroup>
                  <p-inputnumber #startDepthRef [minFractionDigits]="1" [formControlName]="form.formControlNames.startDepth"
                    (onBlur)="onDepthRangeChange(startDepthRef, 'startDepth')" />
                  <p-inputgroup-addon>{{ userUnits.longLengths }} MD</p-inputgroup-addon>
                </p-inputgroup>
                @if (form.formGroup.controls.startDepth.invalid) {
                  <p class="validation-error">Allowed range: {{ drillingRange.start.min }} - {{ drillingRange.start.max }} {{ userUnits.longLengths }}</p>
                }
              </div>

              <div class="flex flex-col">
                <label for="endDrillingMd">End Drilling Depth</label>
                <p-inputgroup>
                  <p-inputnumber #endDepthRef [minFractionDigits]="1" [formControlName]="form.formControlNames.endDepth" (onBlur)="endDepthChanged(endDepthRef)" />
                  <p-inputgroup-addon>{{ userUnits.longLengths }} MD</p-inputgroup-addon>
                </p-inputgroup>
                @if (form.formGroup.controls.endDepth.invalid) {
                  <p class="validation-error">Allowed range: {{ drillingRange.end.min }} - {{ drillingRange.end.max }} {{ userUnits.longLengths }}</p>
                }
              </div>

              @if (wellType?.type == 'Subsea' && currentTubularIndex > 0) {
              <div class="pt-3">
                <p-checkbox
                    size="small" 
                    [formControlName]="form.formControlNames.includeRiser"
                    inputId="includeRiser"
                    binary="true"
                    (onChange)="hasRiserChange();"
                  ></p-checkbox>
                  <label class="pl-2" for="includeRiser">Include Riser</label>
              </div>
              }

            </div>
            <!-- Right Column -->
            <div class="flex flex-col flex-1 min-w-[150px] space-y-2">

              <div class="flex flex-col">
                <label for="fluids">Fluid</label>
                <p-select filter filterBy="state.name" resetFilterOnHide="true" [disabled]="isReadOnly" [options]="fluids" [formControlName]="form.formControlNames.fluid"
                  dataKey="id" appendTo="body" optionLabel="state.name" tooltipPosition="top">
                  <ng-template pTemplate="selectedItem">
                    {{ form.formGroup.value.fluid?.state.name }}
                  </ng-template>
                  <ng-template let-fluid pTemplate="item">
                    {{ fluid.state.name }}
                  </ng-template>
                </p-select>
              </div>

              <div class="flex flex-col">
                <label for="inletTemperature">Inlet Temperature</label>
                @if (!useMudPits) {
                  <p-inputgroup>
                    <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.inletTemperature" />
                    <p-inputgroup-addon>{{ tempUnit }}</p-inputgroup-addon>
                  </p-inputgroup>
                  @if (form.formGroup.controls.inletTemperature.invalid) {
                    <p class="validation-error">Allowed range: {{ temperatureValidation.min }} - {{ temperatureValidation.max }} {{ tempUnit }}</p>
                  }
                }

                @if (useMudPits) {
                  <input type="number" pInputText placeholder="Mud Pits enabled" [disabled]="true" />
                }
              </div>

              <div class="flex flex-col">
                <label for="pressure">Circ on Bottom? / Time</label>
                <p-inputgroup>
                  <span class="scale-75">
                    <p-checkbox [formControlName]="form.formControlNames.isConditionHole"
                      (onChange)="circOnBottomChange($event)" binary="true" [disabled]="isReadOnly"></p-checkbox>
                  </span>
                  <p-inputNumber [minFractionDigits]="2" [class.opacity-50]="conditionHoleDisabled" [class.pointer-events-none]="conditionHoleDisabled"
                    [formControlName]="form.formControlNames.conditionHoleTime">
                  </p-inputNumber>
                  <p-inputgroup-addon>hr</p-inputgroup-addon>
                  @if (form.formGroup.controls.conditionHoleTime.invalid) {
                    <p class="validation-error">Allowed range: 0 - 100000 hrs</p>
                  }
                </p-inputgroup>
              </div>

              <div class="flex flex-col">
                <label for="pressure">POOH? / Time</label>
                <p-inputgroup>
                  <span class="scale-75">
                    <p-checkbox [formControlName]="form.formControlNames.isPoolOutOfHole"
                      (onChange)="poohChange($event)" binary="true" [disabled]="isReadOnly"></p-checkbox>
                  </span>
                  <p-inputNumber [minFractionDigits]="2" [class.opacity-50]="poohDisabled" [class.pointer-events-none]="poohDisabled"
                    [formControlName]="form.formControlNames.poolOutOfHoleTime">
                  </p-inputNumber>
                  <p-inputgroup-addon checkboxAddon>hr</p-inputgroup-addon>
                  @if (form.formGroup.controls.poolOutOfHoleTime.invalid) {
                    <p class="validation-error">Allowed range: 0 - 100000 hrs</p>
                  }
                </p-inputgroup>
              </div>
            </div>
          </div>
        </p-tabpanel>

        <p-tabpanel value="1">
          <p class="{{ drillpipeMissing ? 'validation-error' : 'text-xs mt-2 mb-1' }}">{{ selectedDrillPipe }}</p>
          @if (selectedHwdp && hasHwdp) {
            <p class="text-xs mb-1">{{ selectedHwdp }}</p>
          }
          @if (selectedCollar && hasCollar) {
            <p class="text-xs mb-2">{{ selectedCollar }}</p>
          }

          <div class="flex flex-col pt-2">
            <label for="totalFlowArea">Nozzle Flow Area</label>
            <p-inputgroup>
              <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.totalFlowArea" />
              <p-inputgroup-addon> {{ areaUnit }} </p-inputgroup-addon>
            </p-inputgroup>
            @if (form.formGroup.controls.totalFlowArea.invalid) {
              <p class="validation-error">Allowed range: {{ totalFlowAreaValidation.min }} - {{ totalFlowAreaValidation.max }} {{ areaUnit }}</p>
            }
          </div>
        </p-tabpanel>

        <p-tabpanel value="2">
          <p-fieldset legend="Riser">
            <div class="space-y-2">
              <div class="flex flex-col">
                <label for="outsideDiameter">Outside Diameter</label>
                <p-inputgroup>
                  <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.outsideDiameter" />
                  <p-inputgroup-addon>{{ pipeRoughnessUnit }}</p-inputgroup-addon>
                </p-inputgroup>
              </div>

              <div class="flex flex-col">
                <label for="outsideDiameter">Inside Diameter</label>
                <p-inputgroup>
                  <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.insideDiameter" />
                  <p-inputgroup-addon>{{ pipeRoughnessUnit }}</p-inputgroup-addon>
                </p-inputgroup>
              </div>
            </div>
          </p-fieldset>
        </p-tabpanel>

        <p-tabpanel value="3">
          @if (useMudPits) {
            <app-mud-pit-details
              [disableMudPits]="!useMudPits"
              [previousOperationMudPits]="previousOperationMudPits"
              [userUnits]="userUnits"
              [formControlName]="form.formControlNames.mudPits"
              [surfaceTemperature]="surfaceTemperature"
              [triggerMudPitTempChange]="triggerMudPitTempChange"
            ></app-mud-pit-details>
          }
        </p-tabpanel>

      </p-tabpanels>
    </p-tabs>

  </form>
</app-tool-loader>